import axios from "axios";

const instance = axios.create({
    baseURL:'http://localhost:5001/e-commerce-app-49d5d/us-central1/api'
});

export default instance;